export default __webpack_public_path__ + "static/media/service.87d795bf.jpg";